import { apiSlice } from '../../app/api/apiSlice'
import { generateFormatedURL } from "../urlFormatter";

const contractApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getContractList: builder.query<any, any>({
            query: (args) => "/Contract".concat(generateFormatedURL(args)),
        }),
        getContractById: builder.query<any, any>({
            query: (id) => `/Contract/${id}`
        }),
        updateContract: builder.mutation({
            query: (form) => ({
                url: form?.id == undefined ? "/Contract" : `/Contract/${form.id}`,
                method: form?.id == undefined ? "POST" : "PUT",
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                },
                body: form,
            })
        }),
        getContractDDL: builder.query<any, void>({
            query: () => "Contract/DropdownList"
        }),
    })
});

export const {
    useLazyGetContractListQuery,
    useLazyGetContractByIdQuery,
    useUpdateContractMutation,
    useLazyGetContractDDLQuery,
} = contractApiSlice;
